import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Tip from '../Tip';
import Panel from '../Panel';

export default function ListPanel({ header, operators, tip, children, noPadding, ...others }) {
  return (
    <Root {...others} noPadding={noPadding}>
      <GlobalStyle />
      <Header>
        <Tip style={{ flex: 1, lineHeight: 1.1 }} size='big' content={tip}>
          {header}
        </Tip>
        {operators}
      </Header>
      <Panel className='body-container'>{children}</Panel>
    </Root>
  );
}

const Root = styled.div`
  padding-right: 20px;
  min-width: 800px;
  ${(props) =>
    props.noPadding &&
    `
    .shadow-card-body {
      padding: 0;
    }
  `}
`;

const Header = styled.div`
  margin-bottom: 18px;
  display: flex;
  min-height: 40px;
`;

const GlobalStyle = createGlobalStyle`
  .t-breadcrumb {
    display: none;
  }
  .body-container {
    &&& {
      margin-top: -6px;
      overflow-x: hidden;
    }
  }
`;
